<div id="component-view">
    <ion-spinner *ngIf="_showLoadingSpinner()" id="webrtc-spinner" name="circular" color="light"></ion-spinner>
    <p id="webrtc-view" class="vertical-align-content">
    </p>
</div>
